import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BdbRequest } from '@npm-bbta/bbog-cm-auth-lib';
import { environment } from '../../../../environments/environment';
import '../../../../environments/rxjs-extensions';

@Injectable()

export class HealtyAppService {

    constructor(private bdbRquest: BdbRequest) { }

    getVersion(dataRequest: any): Observable<any> {
        
        return this.bdbRquest.requestGet(environment.endpointHealty, dataRequest)
            .map(response => {
                return response;
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/bdb-identity-number/services/healthy-app.service.ts